import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';

import {
  WalletApi,
  WalletControllerDtoDashboardAvailableBalanceRequest,
  WalletControllerDtoDashboardMiningRequest,
  WalletControllerDtoDashboardUsageAndDestoryRequest, WalletControllerDtoNotificationSettingUpdateRequest,
  WalletControllerDtoTokenSendConditionsUpdateRequest,
  WalletControllerDtoXperTgeRequest,
} from '../../models/src';
import {
  DASHBOARD_AVAILABLE_BALANCE_REQUEST,
  DASHBOARD_MINTING_REQUEST,
  DASHBOARD_SUMMARY_REQUEST,
  DASHBOARD_USAGE_AND_DESTROY_REQUEST,
  NOTIFICATION_SETTING_INFO_REQUEST,
  NOTIFICATION_SETTING_UPDATE,
  TOKEN_SEND_CONDITIONS_INFO_REQUEST,
  TOKEN_SEND_CONDITIONS_UPDATE,
  XPER_MINT,
} from '../../constants/wallet/walletConstants';
import {
  setDashboardAvailableBalance,
  setDashboardMinting,
  setDashboardSummary,
  setDashboardUsageAndDestroy,
  setNotificationSettingInfo,
  setTokenSendConditionsInfo,
  setWalletResponseMessage,
} from '../../actions/wallet/walletActions';
import BaseResponse from '../../models/src/model/BaseResponse';
import WalletControllerDtoDashboardSummaryResponse
  from '../../models/src/model/WalletControllerDtoDashboardSummaryResponse';
import WalletControllerDtoDashboardAvailableBalanceResponse
  from '../../models/src/model/WalletControllerDtoDashboardAvailableBalanceResponse';
import WalletControllerDtoDashboardMiningResponse
  from '../../models/src/model/WalletControllerDtoDashboardMiningResponse';
import WalletControllerDtoDashboardUsageAndDestoryResponse
  from '../../models/src/model/WalletControllerDtoDashboardUsageAndDestoryResponse';
import WalletControllerDtoNotificationSettingInfoResponse
  from '../../models/src/model/WalletControllerDtoNotificationSettingInfoResponse';
import WalletControllerDtoTokenSendConditionsInfoResponse
  from '../../models/src/model/WalletControllerDtoTokenSendConditionsInfoResponse';

const api = new WalletApi(config.API_CLIENT);

// function getUrlVars() {
//   const vars = {};
//   const parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) { // eslint-disable-line
//     vars[key] = value;
//   });
//   return vars;
// }

//= ====================================
//  WATCHERS
//-------------------------------------

function* dashboardSummaryRequestSaga() {
  try {
    const result = yield api.apiWalletDashboardSummaryPost(() => {});
    const data = api.apiClient.deserialize(result, WalletControllerDtoDashboardSummaryResponse);
    yield put(setDashboardSummary(data));
  } catch (e) {
    console.log(e);
  }
}

function* dashboardAvailableBalanceRequestSaga(payload) {
  try {
    const requestData = new WalletControllerDtoDashboardAvailableBalanceRequest();
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.hourly = payload.hourly;
    const result = yield api.apiWalletDashboardAvailableBalancePost(
      { walletControllerDtoDashboardAvailableBalanceRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(
      result,
      WalletControllerDtoDashboardAvailableBalanceResponse,
    );
    yield put(setDashboardAvailableBalance(data.list));
  } catch (e) {
    console.log(e);
  }
}

function* dashboardMintingRequestSaga(payload) {
  try {
    const requestData = new WalletControllerDtoDashboardMiningRequest();
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    const result = yield api.apiWalletDashboardMiningPost(
      { walletControllerDtoDashboardMiningRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(result, WalletControllerDtoDashboardMiningResponse);
    yield put(setDashboardMinting(data.list));
  } catch (e) {
    console.log(e);
  }
}

function* dashboardUsageAndDestroyRequestSaga(payload) {
  try {
    const requestData = new WalletControllerDtoDashboardUsageAndDestoryRequest();
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    const result = yield api.apiWalletDashboardUsageAndDestoryPost(
      { walletControllerDtoDashboardUsageAndDestoryRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(result, WalletControllerDtoDashboardUsageAndDestoryResponse);
    yield put(setDashboardUsageAndDestroy(data.list));
  } catch (e) {
    console.log(e);
  }
}

function* notificationSettingInfoRequestSaga() {
  try {
    yield put(setWalletResponseMessage(null));
    const result = yield api.apiWalletNotificationSettingInfoPost(() => {});
    const data = api.apiClient.deserialize(result, WalletControllerDtoNotificationSettingInfoResponse);
    yield put(setNotificationSettingInfo(data));
  } catch (e) {
    console.log(e);
  }
}

function* notificationSettingUpdateSaga(payload) {
  try {
    yield put(setWalletResponseMessage(null));
    // const requestData = NotificationSettingUpdateReq.constructFromObject(payload);
    const requestData = new WalletControllerDtoNotificationSettingUpdateRequest(payload);
    const result = yield api.apiWalletNotificationSettingUpdatePost({ walletControllerDtoNotificationSettingUpdateRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);
    yield put(setDashboardSummary(data));
    yield put(setWalletResponseMessage(data.resultCode));
  } catch (e) {
    console.log(e);
  }
}

function* tokenSendConditionsInfoRequestSaga() {
  try {
    const result = yield api.apiWalletToeknSendConditionsInfoPost(() => {});
    const data = api.apiClient.deserialize(result, WalletControllerDtoTokenSendConditionsInfoResponse);
    yield put(setTokenSendConditionsInfo(data));
  } catch (e) {
    console.log(e);
  }
}

function* tokenSendConditionsUpdateSaga(payload) {
  try {
    // const requestData = ToeknSendConditionsUpdateReq.constructFromObject(payload);
    const requestData = new WalletControllerDtoTokenSendConditionsUpdateRequest(payload);
    const result = yield api.apiWalletToeknSendConditionsUpdatePost({ walletControllerDtoTokenSendConditionsUpdateRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);
    yield put(setDashboardSummary(data));
  } catch (e) {
    console.log(e);
  }
}

function* xperMintSaga(payload) {
  try {
    yield put(setWalletResponseMessage(null));
    const requestData = new WalletControllerDtoXperTgeRequest();
    requestData.xperQuantity = payload.xperQuantity;
    requestData.twofaNo = payload.twofaNo;
    const result = yield api.apiWalletXperTgePost(
      { walletControllerDtoXperTgeRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(result, BaseResponse);
    yield put(setDashboardSummary(data));
    yield put(setWalletResponseMessage(data.resultCode));
  } catch (e) {
    console.log(e);
  }
}
function* walletRootSaga() {
  yield all([
    takeEvery(DASHBOARD_SUMMARY_REQUEST, dashboardSummaryRequestSaga),
    takeEvery(DASHBOARD_AVAILABLE_BALANCE_REQUEST, dashboardAvailableBalanceRequestSaga),
    takeEvery(DASHBOARD_MINTING_REQUEST, dashboardMintingRequestSaga),
    takeEvery(DASHBOARD_USAGE_AND_DESTROY_REQUEST, dashboardUsageAndDestroyRequestSaga),
    takeEvery(NOTIFICATION_SETTING_INFO_REQUEST, notificationSettingInfoRequestSaga),
    takeEvery(NOTIFICATION_SETTING_UPDATE, notificationSettingUpdateSaga),
    takeEvery(TOKEN_SEND_CONDITIONS_INFO_REQUEST, tokenSendConditionsInfoRequestSaga),
    takeEvery(TOKEN_SEND_CONDITIONS_UPDATE, tokenSendConditionsUpdateSaga),
    takeEvery(XPER_MINT, xperMintSaga),
  ]);
}

const walletSagas = [fork(walletRootSaga)];

export default walletSagas;
